import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CheckDto } from "src/app/shared/models/check-dto";
import { VenueInternet } from "src/app/shared/models/VenueInternet.model";

@Component({
	selector: "app-connector-setup",
	templateUrl: "./connector-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ConnectorSetupComponent implements OnInit {
	checkSelected: CheckDto;
	last24hrs: number;
	last30days: number;

	venueInternetHistory: VenueInternet[];

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenueKey.subscribe((key) => {
			this.venueInternetHistoryGet(key);
		});
	}

	async onCheckSelect(checkKey: string) {
		this.app.loading(true);
		const resp = await this.focuslink.getCheck(this.venueService.venueKey, checkKey);
		this.checkSelected = new CheckDto(resp);
		this.app.loading(false);
	}

	async venueInternetHistoryGet(venueKey) {
		const resp = await this.focuslink.venueInternetGet(venueKey);
		this.venueInternetHistory = resp.map((i) => {
			return new VenueInternet(i);
		});
		this.last24hrs = this.venueInternetHistory.filter((i) => this.app.moment(i.disconnectDateTime).isAfter(this.app.moment().add(-24, "hour"))).length;
		this.last30days = this.venueInternetHistory.filter((i) => this.app.moment(i.disconnectDateTime).isAfter(this.app.moment().add(30, "day"))).length;
	}
}
